import { DateTime } from 'luxon';
import { HOME_TIMEZONE } from '../utils/timezone';

export function getGuestCalendarInitialDate({
  guestStart,
  guestEnd,
  now = DateTime.now(),
  timezone = HOME_TIMEZONE
}) {
  const today = now.setZone(timezone).startOf('day');

  if (today >= guestStart && today <= guestEnd) {
    return today;
  }

  return guestStart;
}
